import { Type } from '@angular/core';
import { UrlMatcher, Data, ResolveData, Routes, LoadChildren, RunGuardsAndResolvers } from '@angular/router';

export interface LosRoute {
    path?: string;
    pathMatch?: string;
    matcher?: UrlMatcher;
    component?: Type<any>;
    redirectTo?: string;
    outlet?: string;
    canActivate?: any[];
    canActivateChild?: any[];
    canDeactivate?: any[];
    canLoad?: any[];
    data?: Data;
    resolve?: ResolveData;
    children?: Routes;
    loadChildren?: LoadChildren;
    runGuardsAndResolvers?: RunGuardsAndResolvers;
    losAuthActivate: boolean;
    losAuthRoles: string[];
}